import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Spin, Row, Col, Button, Input, Form, Select, Switch } from 'antd'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import '../../css/surgeon.scss'
import '../../css/users.scss'
import util from '../../util/util'
import {
  fetchCompany,
  addEditSupportProfile,
} from '../../store/action/company.action'

// Company-level view of the support contact patients see on the app's
// "MoveAI App Support" screen. Deliberately edits only the primary
// (first) support profile — the full multi-profile table stays on the
// super-admin Companies page.
const SupportProfile = (props) => {
  const [profile, setProfile] = useState(undefined)
  const [loaded, setLoaded] = useState(false)
  const [form] = Form.useForm()

  var companyid = props.company && props.company._id

  useEffect(() => {
    getCompany()
  }, [companyid])

  var getCompany = async () => {
    if (!companyid) {
      setLoaded(true)
      return
    }
    var response = await props.getCompany(companyid)
    setLoaded(true)
    if (!response) return
    var primary =
      response.supportprofiles && response.supportprofiles.length > 0
        ? response.supportprofiles[0]
        : undefined
    setProfile(primary)
    form.setFieldsValue({
      name: primary ? primary.name : '',
      email: primary ? primary.email : '',
      phone: primary && primary.phone
        ? primary.phone.charAt(0) == '+'
          ? primary.phone
          : '+' + primary.phone
        : '',
      // Profiles saved before the flag existed have it undefined, meaning on.
      phonesupport: primary ? primary.phonesupport !== false : true,
      timefrom: primary ? primary.timefrom : '',
      timeto: primary ? primary.timeto : '',
      timezone: primary ? primary.timezone : '',
    })
  }

  var handleSubmit = async (value) => {
    var input = {
      companyid,
      name: value.name,
      email: value.email || '',
      phone: value.phone || '',
      phonesupport: value.phonesupport !== false,
      timefrom: value.timefrom || '',
      timeto: value.timeto || '',
      timezone: value.timezone || '',
    }
    // No primary profile yet means this save creates it.
    if (profile) input._id = profile._id
    var response = await props.addEditSupportProfile(input)
    if (!response) return
    getCompany()
  }

  return props.token == undefined ? (
    <Redirect to='/login' />
  ) : (
    <Spin spinning={props.isLoading}>
      <Col className='surgeonAddContainer'>
        <Row align='middle' className='actionRow' justify='space-between'>
          <Col className='headerText'>Support Profile</Col>
        </Row>

        {loaded && !companyid ? (
          <p>No company is associated with your account.</p>
        ) : (
          <Form
            form={form}
            layout={'vertical'}
            onFinish={handleSubmit}
            style={{ maxWidth: 520 }}
          >
            <Form.Item
              label='Name'
              name='name'
              rules={[{ required: true, message: 'Please enter name' }]}
            >
              <Input maxLength={50} />
            </Form.Item>
            <Form.Item
              label='Support Email'
              name='email'
              rules={[{ type: 'email', message: 'Please enter a valid email' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item label='Support Phone' name='phone'>
              <PhoneInput
                className='phone-input'
                defaultCountry={'US'}
                enableAreaCodes
              />
            </Form.Item>
            <Form.Item
              label='Phone Support'
              name='phonesupport'
              valuePropName='checked'
              initialValue={true}
              extra='When off, patients are not shown a phone number. The number above is kept.'
            >
              <Switch checkedChildren='On' unCheckedChildren='Off' />
            </Form.Item>
            <Row gutter={12}>
              <Col flex='50%'>
                <Form.Item label='Support Hours - From' name='timefrom'>
                  <Input placeholder='e.g. 10AM' maxLength={20} />
                </Form.Item>
              </Col>
              <Col flex='50%'>
                <Form.Item label='Support Hours - To' name='timeto'>
                  <Input placeholder='e.g. 3PM' maxLength={20} />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item label='Time Zone' name='timezone'>
              <Select allowClear placeholder='Select time zone'>
                <Select.Option value='Eastern Time'>Eastern Time</Select.Option>
                <Select.Option value='Central Time'>Central Time</Select.Option>
                <Select.Option value='Mountain Time'>
                  Mountain Time
                </Select.Option>
                <Select.Option value='Pacific Time'>Pacific Time</Select.Option>
                <Select.Option value='Alaska Time'>Alaska Time</Select.Option>
                <Select.Option value='Hawaii Time'>Hawaii Time</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item>
              <Button className={'actionBtn'} onClick={() => form.submit()}>
                SAVE
              </Button>
            </Form.Item>
          </Form>
        )}
      </Col>
    </Spin>
  )
}

SupportProfile.propTypes = {
  isLoading: PropTypes.bool,
  token: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    isLoading: state.profile.isLoading,
    company: state.profile.company,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCompany: (companyid) => dispatch(fetchCompany(companyid)),
    addEditSupportProfile: (input) => dispatch(addEditSupportProfile(input)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SupportProfile)
